import {OsmMapRegionParams} from "../../../../../config/cities";

export const hasOsmMapRegionParams = (params: OsmMapRegionParams): boolean =>
    Boolean(params.regionsMapSlug || params.regionsMapParentId != null || params.regionsMapRegionId != null);

/** City polygon only — omit `regionsMapParentId` so regions API does not return district children (`type=6`). */
export const toCityOutlineOsmMapParams = (params: OsmMapRegionParams): OsmMapRegionParams => ({
    regionsMapSlug: params.regionsMapSlug,
    regionsMapRegionId: params.regionsMapRegionId
});
